var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.07692C1 15.423 8.57703 23 17.9231 23H20.4615C21.1348 23 21.7804 22.7326 22.2565 22.2565C22.7326 21.7804 23 21.1348 23 20.4615V18.9136C23 18.3315 22.604 17.8238 22.0388 17.6828L17.0487 16.435C16.5523 16.3109 16.0311 16.497 15.7253 16.9054L14.631 18.3642C14.3128 18.7884 13.7634 18.9757 13.2658 18.7929C11.4188 18.1139 9.74151 17.0415 8.35001 15.65C6.95851 14.2585 5.88611 12.5812 5.20708 10.7342C5.02431 10.2366 5.21159 9.68718 5.6358 9.36903L7.09456 8.27467C7.5041 7.96892 7.68913 7.44656 7.56503 6.95128L6.31723 1.96123C6.24857 1.68673 6.09015 1.44305 5.86714 1.26889C5.64413 1.09474 5.36932 1.00009 5.08636 1H3.53846C2.86522 1 2.21955 1.26744 1.7435 1.7435C1.26744 2.21955 1 2.86522 1 3.53846V6.07692Z",
    stroke: "#DB4B41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a77e85db96ceca9c6003e63f31001956.svg";
export { ForwardRef as ReactComponent };